/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
export const performance = window.performance;
//# sourceMappingURL=performanceBrowser.js.map